<template>
	<tr class="nota-spesa-row" :class="{ 'table-danger text-muted': notaSpesa.FLG_ELIMINATO == 1 }">
		<!-- Selezione -->
		<td v-if="showCheckbox" class="table-head-sm text-center" style="width:2%">
			<input type="checkbox" :checked="notaSpesa.SELEZIONATO == 1" @change="$emit('update:selezionato', $event.target.checked ? 1 : 0)" />
		</td>

		<!-- Utente -->
		<td v-if="showUtente" class="table-head-sm text-muted">{{ notaSpesa.NOME_UTENTE }}</td>

		<!-- Data -->
		<td class="table-head-sm text-muted">{{ filters.formatDate(notaSpesa.DATA) }}</td>

		<!-- Descrizione -->
		<td class="table-head-sm">{{ notaSpesa.DESCRIZIONE }}</td>

		<!-- Categoria -->
		<td class="table-head-sm text-muted">{{ (arrayCategorieSpese.find(c => c.ICONA == notaSpesa.FK_ID_CATEGORIA) || {}).DESCRIZIONE || '' }}</td>

		<!-- Importo -->
		<td class="table-head-sm text-end" :class="notaSpesa.TIPO_MOVIMENTO === 0 ? 'text-danger' : 'text-success'">
			{{ notaSpesa.TIPO_MOVIMENTO === 0 ? '-' : '+' }} € {{ filters.formattaImporto(notaSpesa.IMPORTO) }}
		</td>

		<!-- Progetto -->
		<td v-if="showProgetto" class="table-head-sm">
			<template v-if="notaSpesa.TITOLO_PROGETTO">
				<span v-if="!progettoExpanded">{{ filters.accorciaTesto(notaSpesa.TITOLO_PROGETTO, 20) }}</span>
				<span v-else>{{ notaSpesa.TITOLO_PROGETTO }}</span>
				<i v-if="notaSpesa.TITOLO_PROGETTO.length > 20"
				   :class="progettoExpanded ? 'ph-caret-left' : 'ph-caret-right'"
				   class="ms-1 text-info cursor-pointer"
				   @click.stop="progettoExpanded = !progettoExpanded"></i>
			</template>
			<span v-else class="text-muted">—</span>
		</td>

		<!-- Allegato -->
		<td class="table-head-sm text-center">
			<template v-if="notaSpesa.FILE_ALLEGATO">
				<template v-if="isImmagine(notaSpesa.FILE_ALLEGATO)">
					<i class="ph-image me-1 text-warning"></i>
					<a href="#" @click.prevent="openImmagine()" title="Visualizza immagine" class="text-warning">Immagine</a>
				</template>
				<template v-else>
					<i class="ph-paperclip me-1 text-success"></i>
					<a href="#" @click.prevent="openAllegato()" title="Visualizza allegato" class="text-success">Allegato</a>
				</template>
			</template>
		</td>

		<!-- Azioni -->
		<td class="table-head-sm text-center">
			<div v-if="!readOnly" class="dropdown" ref="dropdownEl" @click.stop>
				<a
					href="#"
					class="text-body p-0"
					@click.prevent="toggleDropdown"
					:aria-expanded="dropdownOpen"
					title="Azioni"
					ref="dropdownToggle"
				>
					<i class="ph-list"></i>
				</a>

				<!-- Teleport il menu dropdown fuori dal contesto della tabella -->
				<Teleport to="body">
					<div
						v-if="dropdownOpen"
						class="dropdown-menu dropdown-menu-end show"
						:style="dropdownStyle"
						@click="handleMenuClick"
					>
						<a v-if="showAssociaProgetto" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'associa', notaSpesa }); closeDropdown()">
							<i class="ph-link-break fa-fw me-2"></i><span class="text-muted me-1">|</span>Associa a progetto
						</a>
						<a v-if="showModifica || !showAssociaProgetto" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'modifica', notaSpesa }); closeDropdown()">
							<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica
						</a>
						<div class="dropdown-divider"></div>
						<a href="#" class="dropdown-item text-danger" v-if="notaSpesa.FLG_ELIMINATO != 1" @click.prevent="$emit('apri-azioni', { azione: 'elimina', notaSpesa }); closeDropdown()">
							<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina
						</a>
						<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && notaSpesa.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni', { azione: 'elimina-definitivamente', notaSpesa }); closeDropdown()">
							<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina definitivamente
						</a>
						<a href="#" class="dropdown-item text-success" v-if="$root.isGod && notaSpesa.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni', { azione: 'ripristina', notaSpesa }); closeDropdown()">
							<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span>Ripristina
						</a>
					</div>
				</Teleport>
			</div>
		</td>
	</tr>

	<Teleport to="body">
		<div v-if="allegatoImgUrl" class="modal fade show" tabindex="-1" role="dialog"
		     style="display: block; background: rgba(0,0,0,0.5);"
		     @click.self="allegatoImgUrl = null">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header bg-secondary text-white">
						<h6 class="modal-title">Immagine allegato</h6>
						<button type="button" class="btn-close btn-close-white" @click="allegatoImgUrl = null"></button>
					</div>
					<div class="modal-body text-center p-2">
						<img :src="allegatoImgUrl" class="img-fluid" alt="Allegato" style="max-height: 70vh;" />
					</div>
				</div>
			</div>
		</div>
	</Teleport>
</template>

<script>
import { useDropdownManager } from '@/composables/useDropdownManager.js';
import { ref } from 'vue';

export default {
	name: 'NotaSpesaNode',
	components: {
	},
	props: {
		notaSpesa: {
			type: Object,
			required: true,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		showAssociaProgetto: {
			type: Boolean,
			default: false,
		},
		showUtente: {
			type: Boolean,
			default: false,
		},
		showProgetto: {
			type: Boolean,
			default: false,
		},
		showModifica: {
			type: Boolean,
			default: false,
		},
		arrayCategorieSpese: {
			type: Array,
			default: () => [],
		},
		showCheckbox: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['apri-azioni', 'update:selezionato'],
	setup() {
		const dropdownManager = useDropdownManager();
		const dropdownId = ref(null);
		const dropdownOpen = ref(false);
		const dropdownStyle = ref({});
		const dropdownToggle = ref(null);

		return {
			dropdownManager,
			dropdownId,
			dropdownOpen,
			dropdownStyle,
			dropdownToggle,
		};
	},
	data() {
		return {
			filters: global.filters,
			allegatoImgUrl: null,
			progettoExpanded: false,
		};
	},
	mounted() {
		// Registra questo dropdown nel sistema centralizzato
		this.dropdownId = this.dropdownManager.registerDropdown(() => {
			this.closeDropdown();
		});

		// Gestisci click fuori dal dropdown per chiuderlo
		document.addEventListener('click', this.handleOutsideClick);
	},
	beforeUnmount() {
		// Pulisci il dropdown dal registro
		if (this.dropdownId) {
			this.dropdownManager.unregisterDropdown(this.dropdownId);
		}
		document.removeEventListener('click', this.handleOutsideClick);
	},
	methods: {
		toggleDropdown() {
			if (this.dropdownOpen) {
				this.closeDropdown();
			} else {
				this.openDropdown();
			}
		},
		openDropdown() {
			this.dropdownManager.openDropdown(this.dropdownId);
			this.dropdownOpen = true;

			this.$nextTick(() => {
				this.updateDropdownPosition();
			});
		},
		closeDropdown() {
			this.dropdownOpen = false;
			this.dropdownManager.closeDropdown(this.dropdownId);
		},
		updateDropdownPosition() {
			if (!this.$refs.dropdownToggle) return;

			const toggle = this.$refs.dropdownToggle;
			const rect = toggle.getBoundingClientRect();

			this.dropdownStyle = {
				position: 'fixed',
				top: `${rect.bottom + 2}px`,
				right: `${window.innerWidth - rect.right}px`,
				left: 'auto',
				zIndex: '99999',
			};
		},
		handleOutsideClick(event) {
			if (!this.dropdownOpen) return;

			const dropdownEl = this.$refs.dropdownEl;
			const toggle = this.$refs.dropdownToggle;

			if (dropdownEl && !dropdownEl.contains(event.target) &&
			    toggle && !toggle.contains(event.target)) {
				this.closeDropdown();
			}
		},
		handleMenuClick(event) {
			event.stopPropagation();
		},
		isImmagine(filePath) {
			return /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath || '');
		},
		openImmagine() {
			const baseUpload = utils.BASE_API + '../../../../thebproject/UPLOAD/';
			this.allegatoImgUrl = baseUpload + (this.notaSpesa.FILE_ALLEGATO || '').replace(/\\/g, '/');
		},
		openAllegato() {
			utils.ajaxBlob('theb/notaspesa/allegato', { ID_NOTA_SPESA: this.notaSpesa.ID_NOTA_SPESA }, (blob) => {
				const url = URL.createObjectURL(blob);
				window.open(url, '_blank');
			}, true, 'POST');
		},
	},
};
</script>

<style scoped>
.nota-spesa-row {
	vertical-align: middle;
}
</style>
